<script setup>
import { nextTick, onBeforeUnmount, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useNuxtApp, useRouteAnnouncer } from '#app'
import PortalShell from '@/components/portal/PortalShell.vue'
import { focusSiteMain } from '@/portal/accessibility.mjs'
const route = useRoute()
const { message } = useRouteAnnouncer({ politeness: 'polite' })
let pendingPath = null
watch(() => route.path, path => { pendingPath = path })
// 비동기 페이지가 준비된 뒤 실제 본문으로 이동한다. 초기 접속은 첫 Tab의 바로가기를 유지한다.
const removeHook = useNuxtApp().hook('page:finish', async () => {
  const path = pendingPath
  await nextTick()
  if (path && path === pendingPath && path === route.path) { pendingPath = null; focusSiteMain() }
})
onBeforeUnmount(removeHook)
</script>
<template><v-app><span class="site-page-announcement" aria-live="polite" aria-atomic="true">{{ message }}</span><NuxtPage v-if="route.meta.academy || route.meta.bare" /><PortalShell v-else><NuxtPage /></PortalShell></v-app></template>
